import { FigureVarDataDto, isFigureVarDataDto } from "./FigureVarDataDto";

/**
 * Represents a single legend entry within a figure.
 */
export interface FigureLegendDataDto {
  id: string;
  legendLabel: string;
  properties: FigureVarDataDto[];
}

/**
 * Type guard to check if an object is a FigureLegendDataDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the legend entry shape.
 */
export const isFigureLegendDataDto = (obj: unknown): obj is FigureLegendDataDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureLegendDataDto;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (typeof chkObj.legendLabel !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((property) => !isFigureVarDataDto(property))) {
    return false;
  }
  return true;
};
